import locales from '../locales';
import { get } from 'lodash';

/**
 * Replace a translations id with a localized string at runtime
 * @param {object} locale - Modcharts locale object
 * @param {string} id - Translation id
 * @param {string[]} replacements - Strings to populate ${n} placeholders
 * @returns {string} - Translated string
 */
const translate = (locale = {}, id = '', replacements = []) => {
	let val = get(locale.translations, id) ||
		get(locales.en_US.translations, id) ||
		id;
	replacements.forEach((row, index) => {
		val = val.replace(`{${index}}`, row);
	});
	return val;
};

export default translate;
